import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getAccessToken,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';

interface CreateSalIdentityFnPayload {
    magicLinkGrant: string;
    email: string;
    countryCode: string;
}

export type CreateSalIdentityFn = (
    payload: CreateSalIdentityFnPayload,
) => Promise<{
    identityId: string;
    accountId: string;
    profileId: string;
    subscriptionId: string;
    grant: string;
}>;

export function initCreateSalIdentityFn({
    dependencies: { appEventSdk, microservicesSdk },
}: DomainInitPayload): CreateSalIdentityFn {
    return async ({
        magicLinkGrant,
        email,
        countryCode,
    }: CreateSalIdentityFnPayload) => {
        const accessToken = getAccessToken();
        try {
            return countryCode.toLowerCase() === 'ca'
                ? await microservicesSdk.domains.identity.createSalIdentityCanada(
                      { magicLinkGrant, email, accessToken },
                  )
                : await microservicesSdk.domains.identity.createSalIdentity({
                      magicLinkGrant,
                      email,
                      accessToken,
                  });
        } catch (error: any) {
            if (
                error.errorCode ===
                    'userServices.userSubscriptionOrchestration.subscriptionAlreadyExistsForIdentity' ||
                error.errorCode == 'SUBSCRIPTION_ALREADY_EXISTS_FOR_IDENTITY'
            ) {
                trackBusinessError(appEventSdk, error);
                throw new Error('SUB_ALREADY_EXISTS_FOR_IDENTITY');
            } else if (error.errorCode == 'CLAIMING_WITH_UNAUTHORIZED_USER') {
                trackBusinessError(appEventSdk, error);
                throw new Error('CLAIMING_WITH_UNAUTHORIZED_USER');
            } else if (
                Array.isArray(error.fieldErrors) &&
                error.fieldErrors.find(
                    (fieldError: any) =>
                        fieldError.errorCode === 'INVALID_EMAIL_ADDRESS',
                )
            ) {
                const invalidEmailError = error.fieldErrors.find(
                    (fieldError: any) =>
                        fieldError.errorCode === 'INVALID_EMAIL_ADDRESS',
                );
                trackBusinessError(appEventSdk, invalidEmailError);
                throw new Error('INVALID_EMAIL_ADDRESS');
            }

            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
